import Text from 'components/Text/Text';
import React, { useContext, useState } from 'react';
import { UserRoles, IItemRestaurant } from 'types';
import DataController from 'components/DataController/DataController';
import Info from './components/Info/Info';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { RestaurantsContext, IRestaurantsContext } from '../../../../../restaurantsState/restaurantsContext';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IItemRestaurant;
	index: number;
}

const Item: React.FC<IItem> = ({ data, index }) => {
	const { setIDForArchiving } = useContext<IRestaurantsContext>(RestaurantsContext);
	const [isOpenInfo, setIsOpenInfo] = useState<boolean>(false);
	const hasArchiveAccess = useRoleAccess([UserRoles.SUPER_USER]);

	const containerClasses = classNames(style.container, { [style.openInfo]: isOpenInfo });
	const addressRowClasses = classNames(style.address, style.row);
	const customerRowClasses = classNames(style.customer, style.row);
	const cityRowClasses = classNames(style.city, style.row);
	const countryRowClasses = classNames(style.country, style.row);
	const actionRowClasses = classNames(style.row, style.action);

	const handleClickInfo = () => {
		setIsOpenInfo(!isOpenInfo);
	};

	const handleSetIdForArchiving = () => {
		setIDForArchiving(data.id);
	};

	return (
		<div data-test={`Item-${index}`}>
			<div className={containerClasses}>
				<Text className={addressRowClasses} translationKey={data.name} withTooltip={true} />
				<Text className={customerRowClasses} translationKey={data.customer.name} withTooltip={true} />
				<Text className={cityRowClasses} translationKey={data.city.name} withTooltip={true} />
				<Text className={countryRowClasses} translationKey={data.country.name} withTooltip={true} />
				<div className={actionRowClasses}>
					<DataController
						onClickInfo={handleClickInfo}
						onClickArchive={hasArchiveAccess ? handleSetIdForArchiving : undefined}
						URLWithIDToEdit={`/clients/restaurants/edit?restaurantID=${data.id}`}
						size="smallBtn"
						isOpenInfo={isOpenInfo}
					/>
				</div>
			</div>
			<Info isOpenInfo={isOpenInfo} data={data} />
		</div>
	);
};

export default Item;
